import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { label: 'Funcionalidades', id: 'funcionalidades' },
    { label: 'Benefícios', id: 'beneficios' },
    { label: 'Planos', id: 'planos' },
    { label: 'Contato', id: 'contato' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    // Mapeamento de nomes para IDs reais das seções
    const sectionMap: Record<string, string> = {
      'funcionalidades': 'funcionalidades',
      'inicio': 'inicio',
      'beneficios': 'comparacao',
      'comparacao': 'comparacao',
      'planos': 'planos',
      'suporte': 'suporte',
      'contato': 'contato',
      'faq': 'faq',
    };

    const targetId = sectionMap[id] || id;
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled || isMobileMenuOpen
          ? 'bg-gray-900/95 backdrop-blur-xl shadow-lg shadow-black/20 border-b border-gray-800/50'
          : 'bg-transparent'
        }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
        <div className="flex items-center justify-between">
          <div
            className="flex items-center gap-2 md:gap-3 cursor-pointer group"
            onClick={() => scrollToSection('inicio')}
          >
            <div className="relative">
              <div className={`absolute inset-0 bg-yellow-500/30 rounded-full blur-md transition-opacity duration-300 ${isScrolled ? 'opacity-0' : 'opacity-100'}`}></div>
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/c2ffb6ae5c67efb323410a310538f1c7/419078b51cfc211422dc0ff93aad6c74.png"
                  alt="Central da Multa"
                  className="w-[56px] h-[56px] md:w-[106px] md:h-[106px] object-contain relative z-10 transition-transform duration-300 group-hover:scale-110"
                />
              </div>
            </div>
            <span className="text-base md:text-xl font-bold text-white transition-all duration-300 group-hover:text-yellow-400">
              Central da Multa
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-2">
            {['Início', 'Funcionalidades', 'Benefícios', 'Planos', 'Contato', 'FAQ'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))}
                className="relative px-4 py-2 text-sm font-medium text-gray-300 hover:text-white transition-all duration-300 whitespace-nowrap group"
              >
                <span className="relative z-10">{item}</span>
                <div className="absolute inset-0 bg-white/5 rounded-lg scale-0 group-hover:scale-100 transition-transform duration-300"></div>
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-amber-500 group-hover:w-full transition-all duration-300"></div>
              </button>
            ))}
            <button
              onClick={() => window.open('https://app.centraldamulta.app.br', '_blank')}
              className="relative ml-4 px-6 py-2.5 bg-gradient-to-r from-yellow-500 to-amber-500 text-gray-900 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap overflow-hidden group hover:shadow-lg hover:shadow-yellow-500/30 hover:scale-105"
            >
              <span className="relative z-10">Login</span>
              <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 to-amber-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:left-[100%] transition-all duration-500"></div>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-700/50 pt-4">
            <div className="flex flex-col gap-2">
              {['Início', 'Funcionalidades', 'Benefícios', 'Planos', 'Contato', 'FAQ'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))}
                  className="px-4 py-3 text-sm font-medium text-gray-300 hover:text-yellow-400 hover:bg-gray-800/50 rounded-lg transition-all duration-300 text-left"
                >
                  {item}
                </button>
              ))}
              <button
                onClick={() => window.open('https://app.centraldamulta.app.br', '_blank')}
                className="mt-2 px-6 py-3 bg-gradient-to-r from-yellow-500 to-amber-500 text-gray-900 rounded-full text-sm font-semibold whitespace-nowrap"
              >
                Login
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
